import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callCobreApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
import { getStrLang } from '../../Translate';
import InputForm from '../../ShowFieldGroupSPEI/inputForm';


const CobrePayment = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingCobreInfo, setLoadingCobreInfo] = useState(false);
    const [infoCobre, setInfoCobre] = useState(sessionStorage.getItem("cobre_info") !== null ? JSON.parse(sessionStorage.getItem("cobre_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")

    useEffect(() => {
        translate();
    }, [translate]);

    const callCobre = () => {
        setLoadingCobreInfo(true);
        if (infoCobre.checkout_url === undefined) {
            callCobreApi(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined && res.success) {
                        const cobreData = { checkout_url: res.checkout_url, checkout_id: res.checkout_id };
                        setInfoCobre(cobreData);
                        sessionStorage.setItem("cobre_info", JSON.stringify(cobreData));
                        setLoadingCobreInfo(false)
                    } else {
                        setErrorMsg("Please, talk with the Administrator.");
                        setLoadingCobreInfo(false);
                        setIsError(true)
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                    setIsError(true)
                }).finally(() => {
                    setLoadingCobreInfo(false);
                    translate();
                });
        }
    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingCobreInfo]);


    useEffect(() => {
        // Call API to get Cobre checkout URL only if not already available
        if (infoCobre.checkout_url === undefined) {
            callCobre()
        }
        return () => {
            const iframe = document.getElementById('cobre_frame');
            if (iframe) {
                iframe.removeEventListener('load', () => { })
            }
        }
    }, [])
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href = redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <>
            {loadingCobreInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {props.payment_type === 'spei_cobre' ? (
                <div className="content content-ted">
                    <div className="col-content">
                        {/* <InputForm
                            for={"nomebanco"}
                            label={getStrLang(lang.nameLang, "bank_name")}
                            data_lang_label={"nome_banck"}
                            value={"NVIO"}
                        />
                        <InputForm
                            for={"favorecido"}
                            label={getStrLang(lang.nameLang, "beneficiary")}
                            data_lang_label={"beneficiary"}
                            value={"Mercado easy solucoes e tecnologia ltda"}
                        /> */}
                        <InputForm
                            for={"clabe"}
                            label={getStrLang(lang.nameLang, "clabe")}
                            data_lang_label={"clabe"}
                            value={"703180052009000030"}
                        />
                        <InputForm
                            for={"reference"}
                            label={'Concepto'}
                            data_lang_label={"reference_number"}
                            value={sessionStorage.getItem("order_no") || ""}
                        />
                        <div className="instruction-text" style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                            <p><strong>{getStrLang(lang.nameLang, "instructions")}</strong></p>
                            <p>{getStrLang(lang.nameLang, "spei_instructions")}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className=''>
                    {infoCobre.checkout_url !== undefined && (
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                                {loading && <div className="loader"> <img src={Loading} alt={"loading"} width="30px" height="30px" /></div>}
                            </div>

                            <iframe
                                id='cobre_frame'
                                src={infoCobre.checkout_url}
                                title="Cobre Payment"
                                width="100%"
                                height="800px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    )}

                    {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                        <h4>{errorMsg}</h4>
                    </div>}
                </div>
            )}
        </>
    )
}

export default CobrePayment;